export const DOCK_KINDS = {
  ELIGIBILITY: 'eligibility',
  EXPORT: 'export',
  KIOSK_PAYMENT: 'kiosk-payment'
};
